import { useDispatch, useSelector } from 'react-redux';
import { cancelBankIDOrder } from './actions';

export function useBankIDOrderStatus() {
  const { status, orderRef, isCancelling } = useSelector(state => state.bankIDOrderStatus);

  const dispatch = useDispatch();

  return {
    status,
    orderRef,
    isCancelling,
    onCancelOrder: () => dispatch(cancelBankIDOrder(orderRef)),
  }
}
